import { useTranslation } from 'react-i18next';

export function AutoSaveIndicator({ status }: { status: 'idle' | 'draft' | 'saving' | 'saved' }) {
  const { t } = useTranslation();
  let text = '';
  let color = 'text-[var(--text-dim)]';
  if (status === 'draft') {
    text = t('notes_ui.editor.autosave_draft');
    color = 'text-amber-600 dark:text-amber-400';
  } else if (status === 'saving') {
    text = t('notes_ui.editor.autosave_saving');
    color = 'text-brand-600 dark:text-brand-300';
  } else if (status === 'saved') {
    text = t('notes_ui.editor.autosave_saved');
    color = 'text-green-600 dark:text-green-400';
  }
  if (!text) return null;
  return (
    <span className={`text-xs ${color} flex-shrink-0`} aria-live="polite">
      {text}
    </span>
  );
}
